import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUnfoldLessComponent } from "./med-icon-unfold-less.component";

@NgModule({
  declarations: [
    MedIconUnfoldLessComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUnfoldLessComponent,
  ],
})
export class MedIconUnfoldLessModule { }
